import { FC, memo, CSSProperties, useState } from 'react';

import { HotelListPriceDetailViewModel } from '@api/index';
import { Currencies } from '@constants/constants';
import FeeDetails from '@components/ui/fee/Details/Details';
import Price, { OriginalPrice } from '@components/ui/price';
import { formatCurrency } from '@utils/utils';

import {
  StartPriceLabel,
  StyledListingItemPriceLabel,
  ItemPriceDetails,
  PriceInEUR,
} from './PriceLabelStyle';

export interface ListingItemLabelProps {
  style?: CSSProperties;
  originalPrice?: number | string;
  sellingPrice?: number | string;
  priceWithDiscount?: number | string;
  peopleCount?: number | string;
  adultCount?: number;
  childCount?: number;
  nightsCount?: number | string;
  currency?: string;
  priceInEUR?: number;
  feeDetails?: HotelListPriceDetailViewModel;
  noSubtitle?: boolean;
}

const PriceLabel: FC<ListingItemLabelProps> = (props) => {
  const {
    adultCount,
    childCount,
    nightsCount,
    originalPrice,
    sellingPrice,
    priceWithDiscount,
    currency = Currencies.TL,
    priceInEUR,
    feeDetails,
    style,
    noSubtitle = false,
    ...otherProps
  } = props;

  const [openFeeDetails, toggleOpenFeeDetails] = useState<boolean>(false);

  return (
    <>
      {priceInEUR && originalPrice ? (
        <OriginalPrice
          price={Number(originalPrice)}
          currency={formatCurrency(currency)}
          noLine={false}
          size={16}
        />
      ) : null}
      <PriceInEUR>
        {priceInEUR ? priceInEUR.toFixed(2) + ' ' + currency : null}
      </PriceInEUR>
      <StyledListingItemPriceLabel
        style={style}
        {...otherProps}
        hasDiscount={!!priceWithDiscount}
      >
        {priceWithDiscount ? (
          <>
            {priceWithDiscount ? (
              <Price
                originalPriceCurrency={currency}
                originalPrice={
                  originalPrice && !priceInEUR
                    ? Number(originalPrice)
                    : undefined
                }
                price={Number(priceWithDiscount)}
                sellingPrice={Number(sellingPrice)}
              />
            ) : null}

            {adultCount || nightsCount || childCount ? (
              <ItemPriceDetails>
                {feeDetails ? (
                  <FeeDetails
                    openFeeDetails={openFeeDetails}
                    toggleOpenFeeDetails={toggleOpenFeeDetails}
                    feeDetails={feeDetails}
                  />
                ) : null}
              </ItemPriceDetails>
            ) : null}
          </>
        ) : null}
      </StyledListingItemPriceLabel>
      {!noSubtitle && priceWithDiscount ? (
        <StartPriceLabel>‘den başlayan fiyatlarla</StartPriceLabel>
      ) : null}
    </>
  );
};

export default memo(PriceLabel);
